const sharedI18n = require('shared/i18n')

module.exports = {
  ...sharedI18n,
  pages: {
    '*': ['common', 'instructor', 'permissions'],
    '/404': ['404'],
    '/sign-in': ['authentication'],
    'rgx:/reports': ['reports'],
    'rgx:/pos-payment': ['pos'],
    'rgx:/widgets': ['widget'],
    'rgx:/basket': ['bookings'],
    'rgx:/time_slots': ['bookings', 'reports']
  }
}
